import React, {Component} from 'react';
import styles from "./LoadingContainer.module.css";
import {Spinner} from "react-bootstrap";

class LoadingContainer extends Component {

    render() {
        const {loading, children} = this.props;
        return (loading)?(
            <div className={styles.AppLogoContainer}>
                <Spinner animation="grow" variant="light" />
            </div>
        ):(
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
}

export default LoadingContainer;